var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "margin", attrs: { justify: "space-between" } },
        [
          _c(
            "el-col",
            [
              _c(
                "el-radio-group",
                {
                  attrs: { value: _vm.cadastro.cadastrante.pessoa.tipo },
                  nativeOn: {
                    change: function($event) {
                      return _vm.clearDocumentos($event)
                    }
                  }
                },
                [
                  _c("el-radio", { attrs: { label: "PF" } }, [
                    _vm._v("Pessoa Física")
                  ]),
                  _c("el-radio", { attrs: { label: "PJ" } }, [
                    _vm._v("Pessoa Jurídica")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "marginTopHeader" },
        [
          _vm.cadastro.cadastrante.pessoa.tipo === "PF"
            ? _c("app-pessoa-fisica-prefeitura", {
                attrs: {
                  pessoa: _vm.cadastro.cadastrante.pessoa,
                  nomeAba: _vm.nomeAba,
                  observer: _vm.observer
                }
              })
            : _vm._e(),
          _vm.cadastro.cadastrante.pessoa.tipo === "PJ"
            ? _c("app-pessoa-juridica", {
                attrs: {
                  pessoa: _vm.cadastro.cadastrante.pessoa,
                  nomeAba: _vm.nomeAba,
                  observer: _vm.observer
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "marginTopHeader" },
        [
          _c(
            "el-row",
            { staticClass: "margimBottom", attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: "required",
                      name: _vm.nomeAba + "/Solicitação",
                      mode: "eager"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          return [
                            _c("app-label", {
                              attrs: { label: "Solicitação:" }
                            }),
                            _c("app-text-editor", {
                              class: { "box-erro-editor": errors.length },
                              attrs: { name: "Solicitação" },
                              model: {
                                value: _vm.cadastro.cadastrante.solicitacao,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.cadastro.cadastrante,
                                    "solicitacao",
                                    $$v
                                  )
                                },
                                expression: "cadastro.cadastrante.solicitacao"
                              }
                            }),
                            _c("span", { staticClass: "help erro" }, [
                              _vm._v(_vm._s(errors[0]))
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "marginTop", attrs: { span: 24 } },
            [
              _c("validation-provider", {
                attrs: { rules: "required", name: _vm.nomeAba + "/Oficio" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", { attrs: { label: "Ofício:" } }),
                        _c("app-upload-area", {
                          staticClass: "uploadOficio",
                          attrs: {
                            id: "oficio",
                            target: _vm.urlUpload,
                            fileType: [
                              "doc",
                              "docx",
                              "jpeg",
                              "jpg",
                              "pdf",
                              "png"
                            ],
                            onSuccess: _vm.onSuccess,
                            documento: _vm.cadastro.cadastrante.oficio,
                            errors: errors,
                            maxSize: 25
                          },
                          on: {
                            download: _vm.download,
                            removerDocumento: _vm.removerDocumento
                          },
                          model: {
                            value: _vm.cadastro.cadastrante.oficio,
                            callback: function($$v) {
                              _vm.$set(_vm.cadastro.cadastrante, "oficio", $$v)
                            },
                            expression: "cadastro.cadastrante.oficio"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c("app-endereco", {
            attrs: {
              endereco: _vm.cadastro.cadastrante.pessoa.endereco,
              nomeAba: _vm.nomeAba
            }
          })
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c("app-documentos", {
            attrs: {
              maxSize: 25,
              "valid-extensions": ["doc", "docx", "jpeg", "jpg", "pdf", "png"],
              documentos: _vm.cadastro.cadastrante.documentos,
              tiposDocumentos: _vm.documentos,
              tiposDocumentosObrigatorios: _vm.documentosObrigatorios,
              observer: _vm.observer,
              aba: _vm.nomeAba
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73dc953f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73dc953f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/para/areasPatrimoniais/components/Cadastrante.vue
// module id = null
// module chunks = 